<template>
    <div class="pc_page" id="pc_page">
    <!-- <div class="pc_loading" id="pc_page"> -->
        <!-- 活动标题 -->
        <div class="wechat-title" v-wechat-title="'迷途之光'"></div>
        <div class="title"></div>
        <div class="time"></div>
        <div class="logo"></div>
        <div class="box">
            <div class="qrcode-box">
                <div id="qrcode" class="qrcode"></div>
            </div>
        </div>

    </div>
</template>
<script>
import { getRandomString } from '@/utils/utils';
export default {
    name: 'anniversary',
    data() {
        return {
        }
    },
    created() {
        var userAgent = navigator.userAgent.toLowerCase();
        var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
        if (isPC) {
            console.log('当前设备是 PC');
        } else {
            this.$router.push(`enter${getRandomString()}`);
            console.log('当前设备不是 PC');
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style lang="less">
@import url("./pc.less");
</style>


// WEBPACK FOOTER //
// src/pages/mitu/order/pc/index.vue